<template>
  <v-container fluid class="payrollrecurring-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-payrollrecurring`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document</v-icon>
            Payroll Recurring
          </v-tab>
          <v-tab-item
            :value="'tab-payrollrecurring'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                    <p class="text-h5">Edit Payroll Recurring</p>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        readonly
                        :items="employees.map(x => {return {text: x.employeename, value: x._id};})"
                        :value="initvalue.employeeid"
                        v-on:change="updateChangedValue($event, 'employeeid')"
                        placeholder="Employee"
                        single-line hint="Please choose the employee">
                      </v-select>
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        :items="accounts.map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.accountid"
                        v-on:change="updateChangedValue($event, 'accountid')"
                        placeholder="Account"
                        single-line hint="Please choose the account">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'paydesc')"
                        v-bind:value="initvalue.paydesc"
                        placeholder="Description"
                        persistent-hint
                        single-line hint="Enter the description">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-form>
                        <v-menu
                          ref="menu_paystartdate"
                          v-model="menu_paystartdate"
                          :close-on-content-click="false"
                          :return-value.sync="paystartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="paystartdate"
                              placeholder="Start Date"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'paystartdate')"
                              v-bind:value="paystartdate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Please choose the start date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="paystartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(paystartdate, 'paystartdate'); $refs.menu_paystartdate.save(paystartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      <v-text-field
                          outlined
                          dense
                          type="number"
                          class="mb-4"
                          placeholder="Value"
                          single-line hint="Enter the amount value"
                          v-on:change="updateChangedValue($event, 'value')"
                          v-bind:value="initvalue.value"
                          v-bind:error="errorindex == 4"
                          persistent-hint
                          >
                        </v-text-field>
                        <v-text-field
                          outlined
                          dense
                          persistent-hint
                          type="number"
                          class="mb-4"
                          single-line hint="Enter the annual limit"
                          placeholder="Annual Limit"
                          v-on:change="updateChangedValue($event, 'valuelimit')"
                          v-bind:value="initvalue.valuelimit"
                          >
                        </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-menu
                          ref="menu_payenddate"
                          v-model="menu_payenddate"
                          :close-on-content-click="false"
                          :return-value.sync="payenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payenddate"
                              placeholder="End Date"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'payenddate')"
                              v-bind:value="payenddate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Please choose the end date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_payenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(payenddate, 'payenddate'); $refs.menu_payenddate.save(payenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                          outlined
                          dense
                          persistent-hint
                          :items=valuetypes
                          class="mb-4"
                          placeholder="Type"
                          single-line hint="Please choose the value type"
                          v-on:change="updateChangedValue($event, 'valuetype')"
                          v-bind:value="initvalue.valuetype"
                          >
                        </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'paystatus')"
                          v-bind:label="initvalue.paystatus"
                          v-model="initvalue.paystatus"
                          value="Active"
                      ></v-switch>
                  </v-col>
                  <v-col cols="12" md="2">
                        <v-select
                          outlined
                          dense
                          persistent-hint
                          :items=frequencies
                          class="mb-4"
                          placeholder="Frequency"
                          single-line 
                          hint="Recurring frequency"
                          v-model="initvalue.recurringfrequency"
                          v-on:change="updateChangedValue($event, 'recurringfrequency'); checkMonth();"
                          v-bind:value="initvalue.recurringfrequency"
                          >
                        </v-select>
                        <v-select
                          outlined
                          dense
                          persistent-hint
                          :items=months
                          class="mb-4"
                          placeholder="Month"
                          single-line 
                          hint="Recurring month"
                          v-model="initvalue.recurringmonth"
                          :disabled="initvalue.recurringfrequency=='Every month'"
                          v-on:change="updateChangedValue($event, 'recurringmonth'); checkMonth();"
                          v-bind:value="initvalue.recurringmonth"
                          >
                        </v-select>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/payrollrecurring/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPayrollRecurring()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      payrollrecurring: {},
      initvalue: {},
      valuetypes: ['Amount', 'Percentage'],
      frequencies: ['Every month', 'Once a year'],
      frequency: null,
      frequencymonth: null,
      months: [
        {text: '', value: null},
        {text: 'January', value: 1},
        {text: 'February', value: 2},
        {text: 'March', value: 3},
        {text: 'April', value: 4},
        {text: 'May', value: 5},
        {text: 'June', value: 6},
        {text: 'July', value: 7},
        {text: 'August', value: 8},
        {text: 'September', value: 9},
        {text: 'October', value: 10},
        {text: 'November', value: 11},
        {text: 'December', value: 12},        
      ],
      paystartdate: null,
      payenddate: null,
      menu_paystartdate: false,
      menu_payenddate: false,
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('PayrollRecurring', ['updatePayrollRecurring','getPayrollRecurringsRequest']),
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    async editPayrollRecurring() {
      this.payrollrecurring._id = this.initvalue._id;
      await this.updatePayrollRecurring(this.payrollrecurring);
      router.push('/payrollrecurring/list');
    },
    updateChangedValue(value, field){
      this.payrollrecurring[field] = value;
    },
    checkMonth(){
      if(this.initvalue.recurringfrequency=='Every month') {
        this.initvalue.recurringmonth = null;
        this.payrollrecurring.recurringmonth = null;
      }
      
    }
  },
  computed: {
    ...mapState('PayrollRecurring', ['isReceiving']),
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'PayrollRecurringList' });
    if(this.employees.length==0){this.getEmployeesRequest()}
    if(this.accounts.length==0){this.getAccountsRequest()}
    if( this.initvalue.paystartdate!==null){
      let d2 = new Date(this.initvalue.paystartdate);
      let month = d2.getMonth()<9 ? "0" + (d2.getMonth()+1).toString() : (d2.getMonth()+1).toString();
      this.paystartdate = d2.getFullYear() + "-" + month + "-" + d2.getDate();
    }
    if( this.initvalue.payenddate!==null){
      let d2 = new Date(this.initvalue.payenddate);
      let month = d2.getMonth()<9 ? "0" + (d2.getMonth()+1).toString() : (d2.getMonth()+1).toString();
      this.payenddate = d2.getFullYear() + "-" + month + "-" + d2.getDate();
    }
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
